import url from '@/utils/url'
import permissionMixin from '@/mixins/permission-mixin'
import targetMixin, { typeTable } from '@/mixins/targetMixin'
import hasMixin from '@/mixins/has-mixin'

export default {
  mixins: [permissionMixin, targetMixin, hasMixin],
  data() {
    return {
      searchModel: '',
      data: null,
      checkedRows: [],
      lastYear: 0,
    }
  },
  watch: {
    $route: 'onRouteHandler',
  },
  created() {
    this.init()
    if (!this.hasTargetTypeTable) {
      localStorage.setItem('typeTable', typeTable.TARGETS_TABLE)
    }
  },
  updated() {
    this.checkEmptyColumn()
  },

  computed: {
    measureTypes() {
      return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint())
        .measure
    },
    items() {
      return this.$store.getters.readUrlEndpoint(this.getEndpoint(this.$route))
    },
    totalRowCount() {
      return Object.keys(this.rows || {}).length
    },
    hasItems() {
      return this.rows && this.tableHeaders && Object.keys(this.rows).length > 0
    },
  },
  methods: {
    switchTypeTable(type, select1_tabs, select1_title) {
      this.typeTable = type
      this.select1_tabs = select1_tabs
      this.select1_title = select1_title
      localStorage.setItem('typeTable', typeTable[type])
      let route = url.getRoute(this.$route)
      route.query.type_table = typeTable[type]
      this.$router.push(route)
      this.getTableData().then(() => {
        this.rebuildRows()
      })
    },

    onDragEnd(evt) {
      this.changeOrder(evt)
    },
    changeOrder({ oldIndex, newIndex }) {
      if (newIndex === oldIndex) {
        return
      }
      let virtualRows = this.rows
      let realRows = this.$refs.tableBody.getElementsByTagName('tr')
      // get min order value
      let minOrder = 0
      for (let key in virtualRows) {
        if (minOrder === 0 || virtualRows[key][0].order < minOrder) {
          minOrder = virtualRows[key][0].order
        }
      }
      // get changed rows orders
      // diff with virtual and real dom
      let changedRows = []
      let notChangedRows = []
      let i = 0
      for (let v of realRows) {
        let order = minOrder + i
        let id = +v.getAttribute('data-id')
        if (
          virtualRows[i] &&
          virtualRows[i][0] &&
          +virtualRows[i][0].id === +id &&
          +order === +virtualRows[i][0].order
        ) {
          notChangedRows.push(id)
        } else {
          // find row by id
          let data = {}
          for (let key in virtualRows) {
            if (+virtualRows[key][0].id === +id) {
              data = virtualRows[key][0]
              break
            }
          }
          data.id = id
          data.order = order
          changedRows.push(data)
        }
        i++
      }
      this.sortable.option('disabled', true)
      this.$bar.start()
      this.sendOrders(changedRows)
        .then(() => {
          this.$bar.finish()
          this.sortable.option('disabled', false)
          this.setDataFromStore()
          // for update data wihout reorders
          this.rebuildRows(true, notChangedRows)
        })
        .catch(() => {
          this.$bar.finish()
          this.sortable.option('disabled', false)
        })
    },
    sendOrders: async function (changedRows = []) {
      for (let i = 0; i < changedRows.length; i++) {
        let v = changedRows[i]
        await this.updateOrder(v, v.order)
      }
      return Promise.resolve(1)
    },
    async init() {
      this.setFiltersFromUrl()
      this.setDataFromStore()
      await this.getCollection()
      this.rebuildRows()
    },
    setDataFromStore() {
      this.data = Object.assign({}, this.items)
    },

    letSearch() {
      let route = url.getRoute(this.$route)
      route.query.q = this.searchModel
      if (!route.query.q) {
        delete route.query.q
      }
      this.$router.push(route)
    },
    onRouteHandler() {
      this.init()
    },
    setFiltersFromUrl() {
      let route = url.getRoute(this.$route)
      this.searchModel = route.query.q || ''
    },
    updateOrder(data = {}, order) {
      return this.$store
        .dispatch('updateModel', {
          url: this.getUpdateUrl(data.id),
          data: {
            id: data.id,
            order: order,
            name: data.name,
            measure_id: data.measure.id,
          },
        })
        .catch((erResponse) => {
          console.error(erResponse)
          this.$e.errorBox(erResponse)
          return erResponse
        })
        .then((r) => {
          // mutate store
          const endpoint = this.getEndpoint(this.$route)
          let storeData = this.$store.getters.readUrlEndpoint(endpoint)
          if (storeData && storeData.data) {
            for (let i = 0; i < storeData.data.length; i++) {
              if (storeData.data[i] && +storeData.data[i].id === +data.id) {
                storeData.data[i].order = order
                break
              }
            }
          }
          return r
        })
    },
    updateScroll(delayed = false) {
      if (delayed === true) {
        setTimeout(() => {
          this.updateScroll()
        }, 0)
        return
      }
      if (this.$refs.tablePS) {
        this.$refs.tablePS.update()
      }
    },
    getId(item) {
      return item.id
    },
    fetchData() {
      const { asyncData } = this.$options
      this.$bar.start()
      asyncData({
        store: this.$store,
        route: this.$route,
        methods: this,
      })
        .then(() => {
          this.init()
          this.$bar.finish()
          this.updateScroll(true)
        })
        .catch(() => {
          this.$bar.finish()
        })
    },
    deleteItem(item) {
      this.$e
        .confirmBox(
          'Удаленную запись нельзя будет восстановить',
          'Удалить запись?'
        )
        .then(() => {
          this.$store
            .dispatch('deleteModel', {
              url: this.getDeleteUrl(item.id),
              data: { id: item.id },
              endpoint: this.getEndpoint(this.$route),
            })
            .then(() => {
              // fix: https://redmine.etton.ru/issues/13316
              this.checkedRows = []
              this.$e.successBox('Запись удалена')
              this.fetchData()
            })
            .catch((erResponse) => {
              console.error(erResponse)
              this.$e.errorBox(erResponse)
            })
        })
    },
    onDeleteItem() {
      if (!this.checkedRows.length) {
        return
      }
      this.checkedRows.forEach((item) => {
        this.deleteItem({ id: item })
      })
      this.checkedRows = []
    },
    onCreateItem() {
      this.redirectToForm(null)
    },
    onEditItem() {
      if (!this.checkedRows.length) {
        return
      }
      this.redirectToForm(this.checkedRows[0])
    },
    redirectToForm(id) {
      const prevRoute = url.getRoute(this.$route, true)
      const type_table = localStorage.getItem('typeTable')

      this.$router.push({
        name: this.$route.name + (id ? '.update' : '.create'),
        params: { id: id, type_table },
        query: {
          prevRoute: prevRoute,
          type_table,
        },
      })
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getEndpoint(route, fromRoute) !== null) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getEndpoint(route, fromRoute),
        })
      )
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  },
}
